import React, { useState, useRef, useEffect } from "react";
import { debounce } from "lodash";

const CategorySearchBar = ({
  searchQuery,
  setSearchQuery
}) => {
  const [localQuery, setLocalQuery] = useState(searchQuery || "");
  const searchBarRef = useRef(null);
  const lastPushedQueryRef = useRef(searchQuery || "");

  useEffect(() => {
    if (searchQuery !== lastPushedQueryRef.current) {
      setLocalQuery(searchQuery || "");
      lastPushedQueryRef.current = searchQuery || "";
    }
  }, [searchQuery]);

  const debouncedSearchRef = useRef(
    debounce((query) => {
      lastPushedQueryRef.current = query;
      setSearchQuery(query);
    }, 300)
  );

  useEffect(() => {
    return () => {
      debouncedSearchRef.current.cancel();
    };
  }, []);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setLocalQuery(query);
    debouncedSearchRef.current(query);
  };

  return (
    <div
      ref={searchBarRef}
      className="w-full px-4"
    >
      <input
        type="text"
        className="bg-slate-50 border border-slate-200 text-slate-800 placeholder-slate-400 rounded-xl px-3 py-1.5 text-sm focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 transition duration-150 w-full focus:outline-none"
        placeholder="Search categories..."
        value={localQuery}
        onChange={handleSearchChange}
      />
    </div>
  );
};

export default CategorySearchBar;